import { z } from 'zod';

import { AiRequestBaseSchema } from './ai-request';

/**
 * Free-form generation — the `complete` half of the provider interface.
 *
 * Served by the `ai-text` capability's single active provider.
 */
export const AiCompletionRequestSchema = AiRequestBaseSchema.extend({
  /** The instruction frame. Sent as the vendor's system prompt, never as a user turn. */
  system: z.string().min(1).max(100_000).optional(),
  /** The material to work on. */
  prompt: z.string().min(1).max(500_000),
  /**
   * The vendor's hard output ceiling for this call.
   *
   * Required, with no platform default: it is the only bound on what a single
   * call can cost, and a default here would be a spend decision made in a
   * contracts file. It is also what the budget guard reserves against before the
   * call is made (N27), so a caller that inflates it pays for the reservation.
   */
  maxOutputTokens: z.number().int().min(1).max(128_000),
}).strict();

export type AiCompletionRequest = z.infer<typeof AiCompletionRequestSchema>;

export const AiCompletionResultSchema = z
  .object({
    text: z.string(),
  })
  .strict();

export type AiCompletionResult = z.infer<typeof AiCompletionResultSchema>;
